<template>
    <div class="scrolling">
      <ul>
        <li v-for="(name, index) in names" :key="index" v-show="index >= currentIndex && index <= (currentIndex + visibleCount - 1)" >{{ name }}</li>
      </ul>                                                   
    </div>
  </template>
   
  <script>
  export default {
    data() {
      return {
        names: ['张三', '李四', '王五','王五2','王五3','王五4','王五5','王五6',
        '王五7','王五8','王五9','王五10','王五11','王五12','王五13'], // 添加更多人名到此处
        currentIndex: 0,
        visibleCount: 1 // 可视化计数，即每次显示的人名数量
      };
    },
    methods: {
      startScrolling() {
        setInterval(() => {
          this.currentIndex++;
          if (this.currentIndex === this.names.length) {
            this.currentIndex = 0;
          }
        }, 200); // 调整间隔时间以达到所需速度
      }
    },
    mounted() {
      this.startScrolling();
    }
  };
  </script>
   
  <style scoped>
  /* 添加CSS样式以美化滚动效果 */
  .scrolling ul li {
    display: inline-block; /* 水平排列 */
    margin-right: 10px; /* 调整项目之间的间距 */
  }
  </style>